/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'facebook-purple': {
    width: 16,
    height: 17,
    viewBox: '0 0 16 17',
    data:
      '<path pid="0" d="M12.286 9.685l.554-3H9.616V5.624c0-1.586.625-2.195 2.244-2.195.502 0 .907.012 1.14.036V.745c-.441-.121-1.52-.243-2.146-.243-3.298 0-4.819 1.549-4.819 4.89v1.293H4v3h2.035v6.528a9.939 9.939 0 003.58.217V9.685h2.671z" _fill="#A363FF"/>'
  }
})
